import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, useMediaQuery } from '@mui/material';
import { Play, Pause } from 'iconsax-react';
import { useVideoControlButton } from '../../hooks/useVideoControlButton';
export const VideoControlButton = ({ sx, breakpoint = '(min-width:1200px)' }) => {
    const isLargeScreen = useMediaQuery(breakpoint);
    const { playing, handlePlayPauseClick, shouldShowButton } = useVideoControlButton();
    if (!isLargeScreen || !shouldShowButton) {
        return null;
    }
    return (_jsx(IconButton, { sx: sx, onClick: handlePlayPauseClick, "aria-label": playing ? 'Pause video' : 'Play video', children: playing ? _jsx(Pause, {}) : _jsx(Play, {}) }));
};
